import { deriveNoopCache } from './cacheImpl.js';
const CHACHE_EXPIRY = 7 * (24 * 60) * (60 * 1000);
let deriveCache;
function wrapCache(keyStart, cache) {
  return {
    del: partial => cache.del("".concat(keyStart).concat(partial)),
    forEach: cache.forEach,
    get: partial => {
      const key = "".concat(keyStart).concat(partial);
      const cached = cache.get(key);
      if (cached) {
        cached.x = Date.now();
        cache.set(key, cached);
        return cached.v;
      }
      return undefined;
    },
    set: (partial, v) => {
      cache.set("".concat(keyStart).concat(partial), {
        v,
        x: Date.now()
      });
    }
  };
}
function clearCache(cache) {
  // clear all expired values
  const now = Date.now();
  const all = [];
  cache.forEach((key, _ref) => {
    let {
      x
    } = _ref;
    now - x > CHACHE_EXPIRY && all.push(key);
  });
  // don't do delete inside loop, just in-case
  all.forEach(key => cache.del(key));
}
export function setDeriveCache() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let cache = arguments.length > 1 ? arguments[1] : undefined;
  deriveCache = cache ? wrapCache("derive:".concat(prefix, ":"), cache) : deriveNoopCache;
  if (cache) {
    clearCache(cache);
  }
}
setDeriveCache();
export { deriveCache };